// @ts-strict-ignore
import React from 'react';
import _ from 'lodash';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import { PriorityPicker } from '@/hybrid/workbooks/PriorityPicker.molecule';
import { getFormFieldProps, getValidationFunction, canUseMemo } from '@/hybrid/formbuilder/formbuilder.utilities';
import { Field, useForm } from 'react-final-form';
import { Placement } from 'react-bootstrap/Overlay';

export interface PriorityPickerIF extends ValidatingFormComponent<any> {
  component: 'PriorityPickerFormComponent';
  placement: Placement;
  buttonTooltip?: string;
  buttonTestId: string;
  buttonClasses: string;
}

const PriorityPickerFormComponentUnwrapped: React.FunctionComponent<PriorityPickerIF> = (props) => {
  const { name, validation, extendValidation, extraClassNames } = props;

  const defaultValidation = (value) => _.isEmpty(value);
  const formState = useForm().getState();

  return (
    <Field name={name} validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
      {({ input, meta }) => (
        <div className={extraClassNames}>
          <PriorityPicker {...getFormFieldProps(formState, input, meta, props)} />
        </div>
      )}
    </Field>
  );
};

export const PriorityPickerFormComponent = React.memo(PriorityPickerFormComponentUnwrapped, canUseMemo);
